import { str } from "./str";

/** The field exactly as given, or null when it is blank — no silent rewrite. */
export function verbatim(value: unknown): string | null {
  const text = str(value);
  return text && text.trim().length > 0 ? text : null;
}
